import { Breadcrumbs, Flex } from '@fullstory/components';
import { Space } from '@fullstory/proto/fs/services/dx-objects';
import { generateRoutePath, SPACE_ROUTE } from '@fullstory/routes';
import React from 'react';
import { PSEUDO_SPACES } from '../../constants';
import { Avatar } from '../Avatar';

export const SpaceBreadcrumb: React.FC<{
  space?: Space | null;
}> = ({ space }) => (
  <>
    {space && !PSEUDO_SPACES.includes(space.id) && (
      <Breadcrumbs.Item to={generateRoutePath(SPACE_ROUTE, { orgId: space.orgId, id: space.id })}>
        <Flex justifyContent="space-between" gap={8}>
          <Avatar size="small" color={space.color} />
          {space.name}
        </Flex>
      </Breadcrumbs.Item>
    )}
  </>
);
